export default "__VITE_ASSET__cb1c743f__"